import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useUIStore } from '@/stores';

const Toaster = ({ ...props }: ToasterProps) => {
  const resolvedTheme = useUIStore((state) => state.resolvedTheme);

  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:rounded-card group-[.toaster]:border group-[.toaster]:border-subtle group-[.toaster]:bg-surface-card group-[.toaster]:text-content-primary group-[.toaster]:shadow-elevated',
          description: 'group-[.toast]:text-content-secondary',
          actionButton:
            'group-[.toast]:border group-[.toast]:border-ink group-[.toast]:bg-ink group-[.toast]:text-parchment',
          cancelButton:
            'group-[.toast]:border group-[.toast]:border-hairline group-[.toast]:bg-paper group-[.toast]:text-content-secondary',
          success: 'group-[.toaster]:border-state-nominal/25 group-[.toaster]:bg-state-nominal-soft',
          warning: 'group-[.toaster]:border-state-warning/25 group-[.toaster]:bg-state-warning-soft',
          error: 'group-[.toaster]:border-state-critical/25 group-[.toaster]:bg-state-critical-soft',
          info: 'group-[.toaster]:border-hairline group-[.toaster]:bg-surface-card',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
